import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchAboutDataIfNeeded } from '@/redux/modules/about';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return dispatch(fetchAboutDataIfNeeded());
};
